export const TRANSITION_DURATION = 300

export enum Direction {
  Forward = 'left',
  Backward = 'right'
}
